// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 623 ? "4dacc674" : chunkId) + "." + {"268":"20550c9ce7389eab","623":"d827aff03a5fcdc4","647":"9635b17a647b1c71"}[chunkId] + ".js";
};